/* eslint-disable array-callback-return */
/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Checkbox from '@material-ui/core/Checkbox';
import { useDispatch, useSelector } from 'react-redux';
import InputAdornment from '@mui/material/InputAdornment';
import { Button } from 'react-bootstrap';
import { setDefaultAuditData } from '../store/actions';
import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { currentcyFormat } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import {
  RX_WITHOUT,
  TWO_DECIMAL_REGEX,
} from '../../../../SharedModules/AppConstants';

function DefaultAudit(props) {
  const {
    payload,
    setDisabledSaveCancelBtn,
    disabledSaveCancelBtn,
    isReadOnly,
    isEnabledByRole,
  } = props;

  const dispatch = useDispatch();

  useEffect(() => {
    if (payload && payload.paramTestVO) {
      initializeDefaultAuditData(payload.paramTestVO);
    }
  }, [payload]);
  const [
    unitsGreaterThenAvgNDCPeviousQuarter,
    setUnitsGreaterThenAvgNDCPeviousQuarter,
  ] = useState();
  const [reimbursedSubmitted, setReimbursedSubmitted] = useState();
  const [
    allowedAmountExceedsSubmittedAmt,
    setAllowedAmountExceedsSubmittedAmt,
  ] = useState();
  const [reimbursedAmtLessThanSubmitted, setReimbursedAmtLessThanSubmitted] =
    useState();
  const [reimbursedAmountLessThanAllowed, setReimbursedAmountLessThanAllowed] =
    useState();
  const [
    amountSubmittedGreaterThanThreshold,
    setAmountSubmittedGreaterThanThreshold,
  ] = useState();
  const [unitsGreaterThanPriorQuarter, setUnitsGreaterThanPriorQuarter] =
    useState();
  const [
    rebateChargedGreaterThanReimbursedAmount,
    setRebateChargedGreaterThanReimbursedAmount,
  ] = useState();
  const [
    rebateForThisNDCExceedsRebateForPreviousQuarter,
    setRebateForThisNDCExceedsRebateForPreviousQuarter,
  ] = useState();
  const [
    rebateForThisLabelerExceedsRebateForPreviousQuarter,
    setRebateForThisLabelerExceedsRebateForPreviousQuarter,
  ] = useState();
  // //
  const [percentAverageUnits, setPercentAverageUnits] = useState({
    defTestPct: null,
  });
  const [percentSubmittedAmount, setPercentSubmittedAmount] = useState({
    defTestPct: null,
  });
  const [
    percentSubmittedAmountReimbursed,
    setPercentSubmittedAmountReimbursed,
  ] = useState({
    defTestPct: null,
  });
  const [percentAllowedAmounts, setPercentAllowedAmounts] = useState({
    defTestPct: null,
  });
  const [thresholdamount, setThresholdamount] = useState({
    defTestAmt: null,
  });
  const [identifyDuplicateClaimsItem, setIdentifyDuplicateClaimsItem] =
    useState({ defTestOnInd: null });

  const [percentPriorquarter, setPercentPriorquarter] = useState({
    defTestPct: null,
  });
  const [percentreimbursedamount, setPercentreimbursedamount] = useState({
    defTestPct: null,
  });
  const [percentPriorquarterNDC, setPercentPriorquarterNDC] = useState({
    defTestPct: null,
  });
  const [percentPriorquarterLabler, setPercentPriorquarterLabler] = useState({
    defTestPct: null,
  });

  const defaultAuditDataRedux = useSelector(
    (state) => state?.sharedState?.SystemProviderReducer?.defaultAuditDataRedux
  );
  const [defaultAuditControlData, setDefaultAuditControlData] = useState(
    defaultAuditDataRedux
  );
  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);

  const validNumber = new RegExp(/^\d*\.?\d*$/);

  useEffect(() => {
    setDefaultAuditControlData(defaultAuditDataRedux);
  }, [defaultAuditDataRedux]);

  const initializeDefaultAuditData = (payloadData) => {
    let percentageUnits = {};
    if (
      defaultAuditControlData &&
      defaultAuditControlData[0] &&
      defaultAuditControlData[0].percentAverageUnits.defTestPct !== null &&
      !disabledSaveCancelBtn
    ) {
      setUnitsGreaterThenAvgNDCPeviousQuarter(
        defaultAuditControlData[0].unitsGreaterThenAvgNDCPeviousQuarter
      );
      setReimbursedSubmitted(defaultAuditControlData[0].reimbursedSubmitted);
      setPercentSubmittedAmount(
        defaultAuditControlData[0].percentSubmittedAmount
      );
      setAllowedAmountExceedsSubmittedAmt(
        defaultAuditControlData[0].allowedAmountExceedsSubmittedAmt
      );
      setPercentSubmittedAmountReimbursed(
        defaultAuditControlData[0].percentSubmittedAmountReimbursed
      );
      setReimbursedAmtLessThanSubmitted(
        defaultAuditControlData[0].reimbursedAmtLessThanSubmitted
      );
      setPercentAllowedAmounts(
        defaultAuditControlData[0].percentAllowedAmounts
      );
      setReimbursedAmountLessThanAllowed(
        defaultAuditControlData[0].reimbursedAmountLessThanAllowed
      );
      setThresholdamount(defaultAuditControlData[0].thresholdamount);
      setAmountSubmittedGreaterThanThreshold(
        defaultAuditControlData[0].amountSubmittedGreaterThanThreshold
      );
      setIdentifyDuplicateClaimsItem(
        defaultAuditControlData[0].identifyDuplicateClaimsItem
      );
      setPercentPriorquarter(defaultAuditControlData[0].percentPriorquarter);
      setUnitsGreaterThanPriorQuarter(
        defaultAuditControlData[0].unitsGreaterThanPriorQuarter
      );
      setPercentreimbursedamount(
        defaultAuditControlData[0].percentreimbursedamount
      );
      setRebateChargedGreaterThanReimbursedAmount(
        defaultAuditControlData[0].rebateChargedGreaterThanReimbursedAmount
      );
      setPercentPriorquarterNDC(
        defaultAuditControlData[0].percentPriorquarterNDC
      );
      setRebateForThisNDCExceedsRebateForPreviousQuarter(
        defaultAuditControlData[0]
          .rebateForThisNDCExceedsRebateForPreviousQuarter
      );
      setPercentPriorquarterLabler(
        defaultAuditControlData[0].percentPriorquarterLabler
      );
      setRebateForThisLabelerExceedsRebateForPreviousQuarter(
        defaultAuditControlData[0]
          .rebateForThisLabelerExceedsRebateForPreviousQuarter
      );
      setPercentAverageUnits(defaultAuditControlData[0].percentAverageUnits);
    } else {
      payloadData.map((item) => {
        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'UNA'
        ) {
          item.defTestOnInd == 1 &&
            setUnitsGreaterThenAvgNDCPeviousQuarter(true);
          percentageUnits = item;
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'RES'
        ) {
          item.defTestOnInd == 1 && setReimbursedSubmitted(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'AES'
        ) {
          setPercentSubmittedAmount({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 && setAllowedAmountExceedsSubmittedAmt(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'SRA'
        ) {
          setPercentSubmittedAmountReimbursed({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 && setReimbursedAmtLessThanSubmitted(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'RLA'
        ) {
          setPercentAllowedAmounts({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 && setReimbursedAmountLessThanAllowed(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'STR'
        ) {
          setThresholdamount({
            ...item,
            defTestAmt: parseFloat(item.defTestAmt || 0).toFixed(2),
          });
          item.defTestOnInd == 1 &&
            setAmountSubmittedGreaterThanThreshold(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'C' &&
          item.paramTestIdVO.defTestTypeCd === 'IDC'
        ) {
          setIdentifyDuplicateClaimsItem(item);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'UNP'
        ) {
          setPercentPriorquarter({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 && setUnitsGreaterThanPriorQuarter(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'RGR'
        ) {
          setPercentreimbursedamount({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 &&
            setRebateChargedGreaterThanReimbursedAmount(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'RGP'
        ) {
          setPercentPriorquarterNDC({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 &&
            setRebateForThisNDCExceedsRebateForPreviousQuarter(true);
        }

        if (
          item.paramTestIdVO.defTestGroupCd === 'I' &&
          item.paramTestIdVO.defTestTypeCd === 'RGL'
        ) {
          setPercentPriorquarterLabler({
            ...item,
            defTestPct: parseFloat(item.defTestPct * 100 || 0).toFixed(2),
          });
          item.defTestOnInd == 1 &&
            setRebateForThisLabelerExceedsRebateForPreviousQuarter(true);
        }
      });
      setPercentAverageUnits({
        ...percentageUnits,
        defTestPct: parseFloat(percentageUnits?.defTestPct * 100 || 0).toFixed(
          2
        ),
      });
    }
  };

  const handleChange = (event, field) => {
    setDisabledSaveCancelBtn(false);
    const inputValue = event.target.value;
    const checkedValue = event.target.checked;
    if (field === 'unitsGreaterThenAvgNDCPeviousQuarter') {
      percentAverageUnits.defTestOnInd = checkedValue ? 1 : 0;
      setUnitsGreaterThenAvgNDCPeviousQuarter(checkedValue);
    }
    if (field === 'reimbursedSubmitted') {
      setReimbursedSubmitted(checkedValue);
    }
    if (field === 'allowedAmountExceedsSubmittedAmt') {
      percentSubmittedAmount.defTestOnInd = checkedValue ? 1 : 0;
      setAllowedAmountExceedsSubmittedAmt(checkedValue);
    }
    if (field === 'reimbursedAmtLessThanSubmitted') {
      percentSubmittedAmountReimbursed.defTestOnInd = checkedValue ? 1 : 0;
      setReimbursedAmtLessThanSubmitted(checkedValue);
    }
    if (field === 'reimbursedAmountLessThanAllowed') {
      percentAllowedAmounts.defTestOnInd = checkedValue ? 1 : 0;
      setReimbursedAmountLessThanAllowed(checkedValue);
    }
    if (field === 'amountSubmittedGreaterThanThreshold') {
      thresholdamount.defTestOnInd = checkedValue ? 1 : 0;
      setAmountSubmittedGreaterThanThreshold(checkedValue);
    }
    if (field === 'identifyDuplicateClaims') {
      identifyDuplicateClaimsItem.defTestOnInd = checkedValue ? 1 : 0;
      setIdentifyDuplicateClaimsItem(checkedValue);
    }
    if (field === 'unitsGreaterThanPriorQuarter') {
      percentPriorquarter.defTestOnInd = checkedValue ? 1 : 0;
      setUnitsGreaterThanPriorQuarter(checkedValue);
    }
    if (field === 'rebateChargedGreaterThanReimbursedAmount') {
      percentreimbursedamount.defTestOnInd = checkedValue ? 1 : 0;
      setRebateChargedGreaterThanReimbursedAmount(checkedValue);
    }
    if (field === 'rebateForThisNDCExceedsRebateForPreviousQuarter') {
      percentPriorquarterNDC.defTestOnInd = checkedValue ? 1 : 0;
      setRebateForThisNDCExceedsRebateForPreviousQuarter(checkedValue);
    }
    if (field === 'rebateForThisLabelerExceedsRebateForPreviousQuarter') {
      percentPriorquarterLabler.defTestOnInd = checkedValue ? 1 : 0;
      setRebateForThisLabelerExceedsRebateForPreviousQuarter(checkedValue);
    }

    //
    if (field === 'percentAverageUnits') {
      setPercentAverageUnits({
        ...percentAverageUnits,
        defTestPct: inputValue,
      });
    }
    if (field === 'percentSubmittedAmount') {
      setPercentSubmittedAmount({
        ...percentAverageUnits,
        defTestPct: inputValue,
      });
    }
    if (field === 'percentSubmittedAmountReimbursed') {
      setPercentSubmittedAmountReimbursed({
        ...percentSubmittedAmountReimbursed,
        defTestPct: inputValue,
      });
    }
    if (field === 'percentAllowedAmounts') {
      setPercentAllowedAmounts({
        ...percentAllowedAmounts,
        defTestPct: inputValue,
      });
    }
    if (field === 'thresholdamount') {
      const inputthresValue = Number(
        event.target.value.replace(/[^0-9\.-]+/g, '')
      );
      setThresholdamount({
        ...thresholdamount,
        defTestAmt: inputthresValue,
      });
    }
    if (field === 'percentPriorquarter') {
      setPercentPriorquarter({
        ...percentPriorquarter,
        defTestPct: inputValue,
      });
    }
    if (field === 'percentreimbursedamount') {
      setPercentreimbursedamount({
        ...percentreimbursedamount,
        defTestPct: inputValue,
      });
    }
    if (field === 'percentPriorquarterNDC') {
      setPercentPriorquarterNDC({
        ...percentPriorquarterNDC,
        defTestPct: inputValue,
      });
    }
    if (field === 'percentPriorquarterLabler') {
      setPercentPriorquarterLabler({
        ...percentPriorquarterLabler,
        defTestPct: inputValue,
      });
    }
  };

  useEffect(() => {
    const data = [
      {
        percentAverageUnits,
        percentSubmittedAmount,
        percentSubmittedAmountReimbursed,
        percentAllowedAmounts,
        thresholdamount,
        identifyDuplicateClaimsItem,
        percentPriorquarter,
        percentreimbursedamount,
        percentPriorquarterNDC,
        percentPriorquarterLabler,
        reimbursedAmountLessThanAllowed,
        amountSubmittedGreaterThanThreshold,
        unitsGreaterThenAvgNDCPeviousQuarter,
        reimbursedSubmitted,
        allowedAmountExceedsSubmittedAmt,
        reimbursedAmtLessThanSubmitted,
        unitsGreaterThanPriorQuarter,
        rebateChargedGreaterThanReimbursedAmount,
        rebateForThisNDCExceedsRebateForPreviousQuarter,
        rebateForThisLabelerExceedsRebateForPreviousQuarter,
      },
    ];
    dispatch(setDefaultAuditData(data));
  }, [
    percentAverageUnits,
    percentSubmittedAmount,
    percentSubmittedAmountReimbursed,
    percentAllowedAmounts,
    thresholdamount,
    identifyDuplicateClaimsItem,
    percentPriorquarter,
    percentreimbursedamount,
    percentPriorquarterNDC,
    percentPriorquarterLabler,
    reimbursedSubmitted,
    allowedAmountExceedsSubmittedAmt,
    reimbursedAmtLessThanSubmitted,
    unitsGreaterThanPriorQuarter,
    rebateChargedGreaterThanReimbursedAmount,
    rebateForThisNDCExceedsRebateForPreviousQuarter,
    rebateForThisLabelerExceedsRebateForPreviousQuarter,
    amountSubmittedGreaterThanThreshold,
    unitsGreaterThenAvgNDCPeviousQuarter,
    reimbursedAmountLessThanAllowed,
  ]);

  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      // LAST_UPDATE_DT: payload && payload.paramTestVO[0].lastUpdateDt,
      DEF_TEST_GROUP_CD:
        payload && payload.paramTestVO[0].paramTestIdVO.defTestGroupCd,
      DEF_TEST_TYPE_CD:
        payload && payload.paramTestVO[0].paramTestIdVO.defTestTypeCd,
      DEF_TEST_UNIT_TYPE_CD:
        payload && payload.paramTestVO[0].paramTestIdVO.defTestUnitTypeCd,
    });
  };
  const [value, setValue] = useState('');

  const keyPressHanlder = (event) => {
    const { key } = event;
    setValue((prevValue) =>
      key !== 'Backspace'
        ? !Number.isNaN(parseInt(key)) || key === ',' || key === '.'
          ? prevValue + key
          : prevValue
        : prevValue.substring(0, prevValue.length - 1)
    );
  };
  return (
    <>
      <div className="default-wrap">
        <fieldset className="custom-fieldset">
          <legend className="same-font-family">Claim</legend>
          <div className="off">
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              !!(
                                defaultAuditControlData &&
                                defaultAuditControlData[0]
                                  .unitsGreaterThenAvgNDCPeviousQuarter
                              )
                            }
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(
                                e,
                                'unitsGreaterThenAvgNDCPeviousQuarter'
                              );
                            }}
                          />
                        }
                        label="Units greater than % average for NDC for previous quarter"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_average_units"
                      label="Percent average units"
                      fullWidth
                      required
                      className="mandate-fields"
                      placeholder=""
                      onChange={(e) => {
                        if (e.target.value && e.target.value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                            handleChange(e, 'percentAverageUnits');
                          } else {
                            return false;
                          }
                        } else if (RX_WITHOUT.test(e.target.value)) {
                          handleChange(e, 'percentAverageUnits');
                        } else {
                          return false;
                        }
                        // if (
                        //   validNumber.test(e.target.value) &&
                        //   e.target.value >= 0
                        // )
                        //   handleChange(e, 'percentAverageUnits');
                      }}
                      onBlur={(e) => {
                        if (e.target.value)
                          setPercentAverageUnits({
                            ...percentAverageUnits,
                            defTestPct: parseFloat(e.target.value || 0).toFixed(
                              2
                            ),
                          });
                      }}
                      value={
                        defaultAuditControlData &&
                        defaultAuditControlData[0].percentAverageUnits
                          ? defaultAuditControlData &&
                            defaultAuditControlData[0].percentAverageUnits
                              .defTestPct
                          : null
                      }
                      disabled={
                        isReadOnly ||
                        !isEnabledByRole ||
                        (defaultAuditControlData &&
                          !defaultAuditControlData[0]
                            .unitsGreaterThenAvgNDCPeviousQuarter)
                      }
                      helperText={
                        !percentAverageUnits.defTestPct &&
                        unitsGreaterThenAvgNDCPeviousQuarter
                          ? constantMessageData.PERCENT_AVERAGE_UNITS_REQ
                          : null
                      }
                      error={
                        !percentAverageUnits.defTestPct &&
                        unitsGreaterThenAvgNDCPeviousQuarter
                          ? constantMessageData.PERCENT_AVERAGE_UNITS_REQ
                          : null
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        min: 0,
                        endAdornment: (
                          <InputAdornment className="suffix-symbol">
                            %
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              !!(
                                defaultAuditControlData &&
                                defaultAuditControlData[0].reimbursedSubmitted
                              )
                            }
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'reimbursedSubmitted');
                            }}
                          />
                        }
                        label="Reimbursed = Submitted"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6" />
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              !!(
                                defaultAuditControlData &&
                                defaultAuditControlData[0]
                                  .allowedAmountExceedsSubmittedAmt
                              )
                            }
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(
                                e,
                                'allowedAmountExceedsSubmittedAmt'
                              );
                            }}
                          />
                        }
                        label="Allowed amount exceeds % submitted amount"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_submitted_amount1"
                      label="Percent submitted amount"
                      fullWidth
                      required
                      placeholder=""
                      className="mandate-fields"
                      onChange={(e) => {
                        if (e.target.value && e.target.value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                            handleChange(e, 'percentSubmittedAmount');
                          } else {
                            return false;
                          }
                        } else if (RX_WITHOUT.test(e.target.value)) {
                          handleChange(e, 'percentSubmittedAmount');
                        } else {
                          return false;
                        }
                        // if (
                        //   validNumber.test(e.target.value) &&
                        //   e.target.value >= 0
                        // )
                        //   handleChange(e, 'percentSubmittedAmount');
                      }}
                      onBlur={(e) => {
                        if (e.target.value)
                          setPercentSubmittedAmount({
                            ...percentAverageUnits,
                            defTestPct: parseFloat(e.target.value || 0).toFixed(
                              2
                            ),
                          });
                      }}
                      helperText={
                        !percentSubmittedAmount.defTestPct &&
                        allowedAmountExceedsSubmittedAmt
                          ? constantMessageData.PERCENT_SUBMITTED_AMOUNT_REQ
                          : null
                      }
                      error={
                        !percentSubmittedAmount.defTestPct &&
                        allowedAmountExceedsSubmittedAmt
                          ? constantMessageData.PERCENT_SUBMITTED_AMOUNT_REQ
                          : null
                      }
                      value={
                        defaultAuditControlData &&
                        defaultAuditControlData[0].percentSubmittedAmount
                          ? defaultAuditControlData &&
                            defaultAuditControlData[0].percentSubmittedAmount
                              .defTestPct
                          : null
                      }
                      disabled={
                        isReadOnly ||
                        !isEnabledByRole ||
                        (defaultAuditControlData &&
                          !defaultAuditControlData[0]
                            .allowedAmountExceedsSubmittedAmt)
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="suffix-symbol">
                            %
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              !!(
                                defaultAuditControlData &&
                                defaultAuditControlData[0]
                                  .reimbursedAmtLessThanSubmitted
                              )
                            }
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(e, 'reimbursedAmtLessThanSubmitted');
                            }}
                          />
                        }
                        label="Reimbursed amount less than % submitted"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_submitted_amount2"
                      label="Percent submitted amount"
                      fullWidth
                      required
                      className="mandate-fields"
                      value={
                        defaultAuditControlData &&
                        defaultAuditControlData[0]
                          .percentSubmittedAmountReimbursed
                          ? defaultAuditControlData &&
                            defaultAuditControlData[0]
                              .percentSubmittedAmountReimbursed.defTestPct
                          : null
                      }
                      placeholder=""
                      onChange={(e) => {
                        if (e.target.value && e.target.value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                            handleChange(e, 'percentSubmittedAmountReimbursed');
                          } else {
                            return false;
                          }
                        } else if (RX_WITHOUT.test(e.target.value)) {
                          handleChange(e, 'percentSubmittedAmountReimbursed');
                        } else {
                          return false;
                        }
                        // if (
                        //   validNumber.test(e.target.value) &&
                        //   e.target.value >= 0
                        // )
                        //   handleChange(e, 'percentSubmittedAmountReimbursed');
                      }}
                      onBlur={(e) => {
                        if (e.target.value)
                          setPercentSubmittedAmountReimbursed({
                            ...percentSubmittedAmountReimbursed,
                            defTestPct: parseFloat(e.target.value || 0).toFixed(
                              2
                            ),
                          });
                      }}
                      disabled={
                        isReadOnly ||
                        !isEnabledByRole ||
                        (defaultAuditControlData &&
                          !defaultAuditControlData[0]
                            .reimbursedAmtLessThanSubmitted)
                      }
                      helperText={
                        !percentSubmittedAmountReimbursed.defTestPct &&
                        reimbursedAmtLessThanSubmitted
                          ? constantMessageData.PERCENT_SUBMITTED_AMOUNT_REQ
                          : null
                      }
                      error={
                        !percentSubmittedAmountReimbursed.defTestPct &&
                        reimbursedAmtLessThanSubmitted
                          ? constantMessageData.PERCENT_SUBMITTED_AMOUNT_REQ
                          : null
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="suffix-symbol">
                            %
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              !!(
                                defaultAuditControlData &&
                                defaultAuditControlData[0]
                                  .reimbursedAmountLessThanAllowed
                              )
                            }
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(
                                e,
                                'reimbursedAmountLessThanAllowed'
                              );
                            }}
                          />
                        }
                        label="Reimbursed amount less than % allowed"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="percent_allowed_amounts"
                      label="Percent Allowed Amounts"
                      fullWidth
                      required
                      placeholder=""
                      className="mandate-fields"
                      onChange={(e) => {
                        if (e.target.value && e.target.value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                            handleChange(e, 'percentAllowedAmounts');
                          } else {
                            return false;
                          }
                        } else if (RX_WITHOUT.test(e.target.value)) {
                          handleChange(e, 'percentAllowedAmounts');
                        } else {
                          return false;
                        }
                        // if (
                        //   validNumber.test(e.target.value) &&
                        //   e.target.value >= 0
                        // )
                        //   handleChange(e, 'percentAllowedAmounts');
                      }}
                      onBlur={(e) => {
                        if (e.target.value)
                          setPercentAllowedAmounts({
                            ...percentAllowedAmounts,
                            defTestPct: parseFloat(e.target.value || 0).toFixed(
                              2
                            ),
                          });
                      }}
                      value={
                        defaultAuditControlData &&
                        defaultAuditControlData[0].percentAllowedAmounts
                          ? defaultAuditControlData &&
                            defaultAuditControlData[0].percentAllowedAmounts
                              .defTestPct
                          : null
                      }
                      disabled={
                        isReadOnly ||
                        !isEnabledByRole ||
                        (defaultAuditControlData &&
                          !defaultAuditControlData[0]
                            .reimbursedAmountLessThanAllowed)
                      }
                      helperText={
                        !percentAllowedAmounts.defTestPct &&
                        reimbursedAmtLessThanSubmitted
                          ? constantMessageData.PERCENT_ALLOWED_AMOUNT_REQ
                          : null
                      }
                      error={
                        !percentAllowedAmounts.defTestPct &&
                        reimbursedAmtLessThanSubmitted
                          ? constantMessageData.PERCENT_ALLOWED_AMOUNT_REQ
                          : null
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="suffix-symbol">
                            %
                          </InputAdornment>
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form no-margin min-md">
                    <div className="sub-radio text-black sub-label">
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            checked={
                              !!(
                                defaultAuditControlData &&
                                defaultAuditControlData[0]
                                  .amountSubmittedGreaterThanThreshold
                              )
                            }
                            disabled={isReadOnly || !isEnabledByRole}
                            onChange={(e) => {
                              handleChange(
                                e,
                                'amountSubmittedGreaterThanThreshold'
                              );
                            }}
                          />
                        }
                        label="Amount submitted greater than threshold"
                        labelPlacement="end"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-wrapper vertical-wrapper">
                  <div className="mui-custom-form with-select input-md override-width-95">
                    <TextField
                      id="threshold_amount"
                      label="Threshold amount"
                      fullWidth
                      required
                      className="mandate-fields dollar-symbol"
                      placeholder=""
                      onChange={(e) => {
                        const value = e.target.value.replace(/[^0-9\.-]+/g, '');
                        if (value && value.includes('.')) {
                          if (TWO_DECIMAL_REGEX.test(value)) {
                            setThresholdamount({
                              ...thresholdamount,
                              defTestAmt: Number(value),
                            });
                          } else {
                            return false;
                          }
                        } else if (RX_WITHOUT.test(value)) {
                          setThresholdamount({
                            ...thresholdamount,
                            defTestAmt: Number(value),
                          });
                        } else {
                          return false;
                        }
                        // handleChange(e, 'thresholdamount');
                      }}
                      onBlur={(e) => {
                        if (e.target.value) {
                          const val = Number(
                            e.target.value.replace(/[^0-9\.-]+/g, '')
                          );
                          setThresholdamount({
                            ...thresholdamount,
                            defTestAmt: parseFloat(val).toFixed(2),
                          });
                        }
                      }}
                      value={
                        defaultAuditControlData &&
                        defaultAuditControlData[0].thresholdamount
                          ? defaultAuditControlData &&
                            currentcyFormat(
                              defaultAuditControlData[0].thresholdamount
                                .defTestAmt
                            )
                          : null
                      }
                      disabled={
                        isReadOnly ||
                        !isEnabledByRole ||
                        (defaultAuditControlData &&
                          !defaultAuditControlData[0]
                            .amountSubmittedGreaterThanThreshold)
                      }
                      helperText={
                        !thresholdamount.defTestAmt &&
                        amountSubmittedGreaterThanThreshold
                          ? constantMessageData.THRESHOLD_AMOUNT_REQ
                          : null
                      }
                      error={
                        !thresholdamount.defTestAmt &&
                        amountSubmittedGreaterThanThreshold
                          ? constantMessageData.THRESHOLD_AMOUNT_REQ
                          : null
                      }
                      InputProps={{
                        inputProps: {
                          maxlength: 15,
                          style: { textAlign: 'right' },
                        },
                        endAdornment: (
                          <InputAdornment className="suffix-symbol" />
                        ),
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="no-margin min-md">
                  <div className="sub-radio text-black sub-label disable-chk">
                    <FormControlLabel
                      control={
                        <Checkbox color="primary" checked={false} disabled />
                      }
                      label="Identify duplicate claims"
                      labelPlacement="end"
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-3" />
            </div>
          </div>
          {/* </form> */}
        </fieldset>
        <fieldset className="custom-fieldset">
          <legend className="same-font-family">Invoice</legend>
          <form autoComplete="off">
            <div className="off">
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={
                                !!(
                                  defaultAuditControlData &&
                                  defaultAuditControlData[0]
                                    .unitsGreaterThanPriorQuarter
                                )
                              }
                              disabled={isReadOnly || !isEnabledByRole}
                              onChange={(e) => {
                                handleChange(e, 'unitsGreaterThanPriorQuarter');
                              }}
                            />
                          }
                          label="Units greater than % prior quarter"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_prior_qurater1"
                        label="Percent prior quarter"
                        fullWidth
                        className="mandate-fields"
                        placeholder=""
                        onChange={(e) => {
                          if (e.target.value && e.target.value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                              handleChange(e, 'percentPriorquarter');
                            } else {
                              return false;
                            }
                          } else if (RX_WITHOUT.test(e.target.value)) {
                            handleChange(e, 'percentPriorquarter');
                          } else {
                            return false;
                          }
                          // if (
                          //   validNumber.test(e.target.value) &&
                          //   e.target.value >= 0
                          // )
                          //   handleChange(e, 'percentPriorquarter');
                        }}
                        onBlur={(e) => {
                          if (e.target.value)
                            setPercentPriorquarter({
                              ...percentPriorquarter,
                              defTestPct: parseFloat(e.target.value).toFixed(2),
                            });
                        }}
                        value={
                          defaultAuditControlData &&
                          defaultAuditControlData[0].percentPriorquarter
                            ? defaultAuditControlData &&
                              defaultAuditControlData[0].percentPriorquarter
                                .defTestPct
                            : null
                        }
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          (defaultAuditControlData &&
                            !defaultAuditControlData[0]
                              .unitsGreaterThanPriorQuarter)
                        }
                        helperText={
                          !percentPriorquarter.defTestPct &&
                          unitsGreaterThanPriorQuarter
                            ? constantMessageData.PERCENT_PRIOR_QUARTER_REQ
                            : null
                        }
                        error={
                          !percentPriorquarter.defTestPct &&
                          unitsGreaterThanPriorQuarter
                            ? constantMessageData.PERCENT_PRIOR_QUARTER_REQ
                            : null
                        }
                        InputProps={{
                          inputProps: {
                            maxlength: 15,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="suffix-symbol">
                              %
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={
                                !!(
                                  defaultAuditControlData &&
                                  defaultAuditControlData[0]
                                    .rebateChargedGreaterThanReimbursedAmount
                                )
                              }
                              disabled={isReadOnly || !isEnabledByRole}
                              onChange={(e) => {
                                handleChange(
                                  e,
                                  'rebateChargedGreaterThanReimbursedAmount'
                                );
                              }}
                            />
                          }
                          label="Rebate charged greater than % reimbursed amount"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_reimbursed_amount"
                        label="Percent reimbursed amount"
                        fullWidth
                        required
                        className="mandate-fields"
                        placeholder=""
                        onChange={(e) => {
                          if (e.target.value && e.target.value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                              handleChange(e, 'percentreimbursedamount');
                            } else {
                              return false;
                            }
                          } else if (RX_WITHOUT.test(e.target.value)) {
                            handleChange(e, 'percentreimbursedamount');
                          } else {
                            return false;
                          }
                          // if (
                          //   validNumber.test(e.target.value) &&
                          //   e.target.value >= 0
                          // )
                          //   handleChange(e, 'percentreimbursedamount');
                        }}
                        onBlur={(e) => {
                          if (e.target.value)
                            setPercentreimbursedamount({
                              ...percentreimbursedamount,
                              defTestPct: parseFloat(e.target.value).toFixed(2),
                            });
                        }}
                        value={
                          defaultAuditControlData &&
                          defaultAuditControlData[0].percentreimbursedamount
                            ? defaultAuditControlData &&
                              defaultAuditControlData[0].percentreimbursedamount
                                .defTestPct
                            : null
                        }
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          (defaultAuditControlData &&
                            !defaultAuditControlData[0]
                              .rebateChargedGreaterThanReimbursedAmount)
                        }
                        helperText={
                          !percentreimbursedamount.defTestPct &&
                          rebateChargedGreaterThanReimbursedAmount
                            ? constantMessageData.PERCENT_REIMBURSED_AMOUNT_REQ
                            : null
                        }
                        error={
                          !percentreimbursedamount.defTestPct &&
                          rebateChargedGreaterThanReimbursedAmount
                            ? constantMessageData.PERCENT_REIMBURSED_AMOUNT_REQ
                            : null
                        }
                        InputProps={{
                          inputProps: {
                            maxlength: 15,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="subfix-symbol">
                              %
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={
                                !!(
                                  defaultAuditControlData &&
                                  defaultAuditControlData[0]
                                    .rebateForThisNDCExceedsRebateForPreviousQuarter
                                )
                              }
                              disabled={isReadOnly || !isEnabledByRole}
                              onChange={(e) => {
                                handleChange(
                                  e,
                                  'rebateForThisNDCExceedsRebateForPreviousQuarter'
                                );
                              }}
                            />
                          }
                          label="Rebate for this NDC exceeds % rebate for previous quarter"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_prior_qurater2"
                        label="Percent prior quarter"
                        fullWidth
                        required
                        className="mandate-fields"
                        placeholder=""
                        onChange={(e) => {
                          if (e.target.value && e.target.value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                              handleChange(e, 'percentPriorquarterNDC');
                            } else {
                              return false;
                            }
                          } else if (RX_WITHOUT.test(e.target.value)) {
                            handleChange(e, 'percentPriorquarterNDC');
                          } else {
                            return false;
                          }
                          // if (
                          //   validNumber.test(e.target.value) &&
                          //   e.target.value >= 0
                          // )
                          //   handleChange(e, 'percentPriorquarterNDC');
                        }}
                        onBlur={(e) => {
                          if (e.target.value)
                            setPercentPriorquarterNDC({
                              ...percentPriorquarterNDC,
                              defTestPct: parseFloat(e.target.value).toFixed(2),
                            });
                        }}
                        value={
                          defaultAuditControlData &&
                          defaultAuditControlData[0].percentPriorquarterNDC
                            ? defaultAuditControlData &&
                              defaultAuditControlData[0].percentPriorquarterNDC
                                .defTestPct
                            : null
                        }
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          (defaultAuditControlData &&
                            !defaultAuditControlData[0]
                              .rebateForThisNDCExceedsRebateForPreviousQuarter)
                        }
                        helperText={
                          !percentPriorquarterNDC.defTestPct &&
                          rebateForThisNDCExceedsRebateForPreviousQuarter
                            ? constantMessageData.PERCENT_PRIOR_QUARTER_REQ
                            : null
                        }
                        error={
                          !percentPriorquarterNDC.defTestPct &&
                          rebateForThisNDCExceedsRebateForPreviousQuarter
                            ? constantMessageData.PERCENT_PRIOR_QUARTER_REQ
                            : null
                        }
                        InputProps={{
                          inputProps: {
                            maxlength: 15,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="suffix-symbol">
                              %
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form no-margin min-md">
                      <div className="sub-radio text-black sub-label">
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="primary"
                              checked={
                                !!(
                                  defaultAuditControlData &&
                                  defaultAuditControlData[0]
                                    .rebateForThisLabelerExceedsRebateForPreviousQuarter
                                )
                              }
                              disabled={isReadOnly || !isEnabledByRole}
                              onChange={(e) => {
                                handleChange(
                                  e,
                                  'rebateForThisLabelerExceedsRebateForPreviousQuarter'
                                );
                              }}
                            />
                          }
                          label="Rebate for this labeler exceeds % rebate for previous quarter"
                          labelPlacement="end"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-wrapper vertical-wrapper">
                    <div className="mui-custom-form with-select input-md override-width-95">
                      <TextField
                        id="percent_prior_qurater3"
                        label="Percent prior quarter"
                        fullWidth
                        required
                        className="mandate-fields"
                        placeholder=""
                        onChange={(e) => {
                          if (e.target.value && e.target.value.includes('.')) {
                            if (TWO_DECIMAL_REGEX.test(e.target.value)) {
                              handleChange(e, 'percentPriorquarterLabler');
                            } else {
                              return false;
                            }
                          } else if (RX_WITHOUT.test(e.target.value)) {
                            handleChange(e, 'percentPriorquarterLabler');
                          } else {
                            return false;
                          }
                          // if (
                          //   validNumber.test(e.target.value) &&
                          //   e.target.value >= 0
                          // )
                          //   handleChange(e, 'percentPriorquarterLabler');
                        }}
                        onBlur={(e) => {
                          if (e.target.value)
                            setPercentPriorquarterLabler({
                              ...percentPriorquarterLabler,
                              defTestPct: parseFloat(
                                e.target.value || 0
                              ).toFixed(2),
                            });
                        }}
                        value={
                          defaultAuditControlData &&
                          defaultAuditControlData[0].percentPriorquarterLabler
                            ? defaultAuditControlData &&
                              defaultAuditControlData[0]
                                .percentPriorquarterLabler.defTestPct
                            : null
                        }
                        disabled={
                          isReadOnly ||
                          !isEnabledByRole ||
                          (defaultAuditControlData &&
                            !defaultAuditControlData[0]
                              .rebateForThisLabelerExceedsRebateForPreviousQuarter)
                        }
                        helperText={
                          !percentPriorquarterLabler.defTestPct &&
                          rebateForThisLabelerExceedsRebateForPreviousQuarter
                            ? constantMessageData.PERCENT_PRIOR_QUARTER_REQ
                            : null
                        }
                        error={
                          !percentPriorquarterLabler.defTestPct &&
                          rebateForThisLabelerExceedsRebateForPreviousQuarter
                            ? setDisabledSaveCancelBtn(true) &&
                              constantMessageData.PERCENT_PRIOR_QUARTER_REQ
                            : null
                        }
                        InputProps={{
                          inputProps: {
                            maxlength: 15,
                            style: { textAlign: 'right' },
                          },
                          endAdornment: (
                            <InputAdornment className="suffix-symbol">
                              %
                            </InputAdornment>
                          ),
                        }}
                        InputLabelProps={{
                          shrink: true,
                        }}
                      />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-12">
                  <div className="btn-wrapper float-right mr-4">
                    <Button
                      className="btn btn-success btn-save btn-primary"
                      data-testid="view-history"
                      type="button"
                      onClick={() => {
                        handleViewHistory();
                      }}
                    >
                      <SVGComponent iconName="Icon-view-history" /> View History
                    </Button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </fieldset>
      </div>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="PARAM_TEST"
          keyValue={keyValue}
        />
      )}
    </>
  );
}
export default withRouter(DefaultAudit);
